module.exports = __webpack_public_path__ + "public/images/chess.3415ea4a093d1af5a37a8b790a4f6b5f.png";